'use client';
import { jsx } from '@emotion/react/jsx-runtime';
import { forwardRef } from 'react';
import { createPolymorphicComponent, Box } from '@s7/base';
import { useReducedMotion } from '@s7/hooks';
import { useProps, useTheme } from '@s7/styles';
import { IDENT, defaultProps } from './Collapse.contract.js';
import { useCollapse } from './useCollapse/useCollapse.js';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const _Collapse = /*#__PURE__*/ forwardRef((props, ref)=>{
    const _useProps = useProps(IDENT, props, defaultProps), [{ children, opened, transitionDuration, timingFunction, style, onTransitionEnd, animateOpacity }] = _useProps, others = _object_without_properties_loose(_useProps[0], [
        "children",
        "opened",
        "transitionDuration",
        "timingFunction",
        "style",
        "onTransitionEnd",
        "animateOpacity"
    ]);
    const theme = useTheme();
    const shouldReduceMotion = useReducedMotion();
    const reduceMotion = theme.respectReducedMotion ? shouldReduceMotion : false;
    const duration = reduceMotion ? 0 : transitionDuration;
    const getCollapseProps = useCollapse({
        opened,
        transitionDuration,
        timingFunction,
        onTransitionEnd
    });
    if (duration === 0) {
        return opened ? /*#__PURE__*/ jsx(Box, _extends({}, others, {
            children: children
        })) : null;
    }
    return /*#__PURE__*/ jsx(Box, _extends({}, getCollapseProps(_extends({
        style,
        ref
    }, others)), {
        children: /*#__PURE__*/ jsx("div", {
            style: {
                minHeight: 0,
                opacity: opened || !animateOpacity ? 1 : 0,
                transition: animateOpacity ? `opacity ${transitionDuration}ms ${timingFunction}` : 'none'
            },
            children: children
        })
    }));
});
const Collapse = createPolymorphicComponent(_Collapse);
var Collapse$1 = Collapse;
Collapse.displayName = IDENT;

export { Collapse, _Collapse, Collapse$1 as default };
//# sourceMappingURL=Collapse.js.map
